import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import i18next from 'i18next';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { OrderService } from 'src/app/core/services/order.service';
import { StorageService } from 'src/app/core/storage/storage.service';
import { FeedbackModalComponent } from 'src/app/shared/components/feedback-modal/feedback-modal.component';
import { StepperComponent } from 'src/app/shared/components/stepper/stepper.component';
import { User } from 'src/app/shared/model/user.model';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  standalone: true,
  selector: 'app-book-vehicle',
  templateUrl: './book-vehicle.component.html',
  styleUrls: ['./book-vehicle.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    StepperComponent
  ]
})
export class BookVehicleComponent implements OnInit, AfterViewInit {
  @ViewChild('stepperHeader') stepperHeader!: ElementRef;
  spinner = false;
  steps = new Map<string, boolean>();
  user!: User;
  requestNumber!: string;
  landing2 = false;
  loading = false;

  constructor(
    private orderService: OrderService,
    public dialog: MatDialog,
    private storageService: StorageService,
    private route: ActivatedRoute,
    private navigationService: NavigationService
  ) {}

  ngOnInit(): void {
    this.landing2 = this.storageService.get('landing2') || false;
    this.storageService.set('navigation', 'bookVehicle');
    this.user = this.storageService.get('config');
    this.route.paramMap.subscribe((params) => {
      this.requestNumber = params.get('requestNumber')!;
    });
    this.setSteps();
    setTimeout(() => {
      this.adjustStepper();
    }, 100);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.navigationService.handleNavigationView('bookVehicle');
    }, 0);
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.adjustStepper();
  }

  sendRequest(newRequestData: any) {
    this.loading = true;
    const body = {
      petitionerType: newRequestData.requestInfo?.petitionerType,
      name: newRequestData.requestInfo?.name,
      firstSurname: newRequestData.requestInfo?.firstSurname,
      secondSurname: newRequestData.requestInfo?.secondSurname,
      telephone: newRequestData.requestInfo?.phone,
      email: newRequestData.requestInfo?.email,
      comments: newRequestData.comments,
      requestNumber: this.requestNumber
    };

    this.orderService.bookVehicle(body).subscribe({
      next: () => {
        this.loading = false;
        this.dialog.open(FeedbackModalComponent, {
          data: {
            text: i18next.t('newBookOK'),
            redirect: true,
            list: true,
            theme: 'ligth'
          }
        });
      },
      error: () => {
        this.loading = false;
        this.dialog.open(FeedbackModalComponent, {
          data: {
            text: i18next.t('newBookKO'),
            close: true,
            theme: 'ligth'
          }
        });
      }
    });
  }

  setSteps() {
    this.steps.set('vehicle-finder', false);
    this.steps.set('approvers', false);
    this.steps.set('request-info', true);
    this.steps.set('car-config', false);
    this.steps.set('replacementvehicle', false);
    this.steps.set('additionalInfo', true);
  }

  adjustStepper() {
    const stepperHeaderContainer: any = document.querySelector(
      '.mat-horizontal-stepper-header-container'
    );
    if (stepperHeaderContainer) {
      //scale 0.8
      stepperHeaderContainer.style.transform = 'scale(0.8)';
      stepperHeaderContainer.style.transformOrigin = 'center right';

      const offY = stepperHeaderContainer.offsetHeight / 2;

      const stepperHeader = this.stepperHeader.nativeElement;
      const x = stepperHeader.getBoundingClientRect().x;

      const right = window.innerWidth - x;
      stepperHeaderContainer.style.position = 'absolute';
      stepperHeaderContainer.style.top = stepperHeader.offsetTop - offY + 'px';
      stepperHeaderContainer.style.right = right + 'px';
    }
    if (stepperHeaderContainer && window.innerWidth <= 1024) {
      stepperHeaderContainer.style.transformOrigin = 'center left';
      stepperHeaderContainer.style['flex-wrap'] = 'wrap';
      stepperHeaderContainer.style.position = 'unset';
    }
  }

}
